<template>
    <v-app id="inspire">
        <v-main>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4>
                        <v-card v-if="!sendedMail" class="elevation-12">
                            <v-toolbar dark color="primary">
                                <v-toolbar-title
                                    >Jacob Store Manager - Recupero
                                    password</v-toolbar-title
                                >
                            </v-toolbar>
                            <v-card-text class="text-center">
                                <p>
                                    Per recuperare la passowrd inserisci la tua
                                    email.
                                </p>
                                <v-alert
                                    border="left"
                                    color="red"
                                    type="error"
                                    v-if="errorString"
                                    v-html="errorString"
                                ></v-alert>
                                <v-form>
                                    <v-text-field
                                        prepend-icon="person"
                                        name="email"
                                        label="E-Mail"
                                        type="email"
                                        v-model="email"
                                    ></v-text-field>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    :loading="loading"
                                    color="primary"
                                    @click="richiestaRecuperoPassword()"
                                    >Recupera</v-btn
                                >
                            </v-card-actions>
                        </v-card>
                        <v-card v-else class="elevation-12">
                            <v-toolbar dark color="primary">
                                <v-toolbar-title
                                    >Jacob Store Manager</v-toolbar-title
                                >
                            </v-toolbar>
                            <v-card-text class="text-center">
                                <p>
                                    <b
                                        >Il link per il recupero della password
                                        è stato mandato al tuo indirizzo email.
                                        Se non hai ricevuto l'email, controlla
                                        la cartella SPAM.</b
                                    >
                                </p>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import requests from "../requests";
import helpers from "../helpers";
export default {
    name: "Login",
    props: {
        source: String,
    },

    data: () => {
        return {
            email: "",
            password: "",
            loading: false,
            errorString: false,
            sendedMail: false,
        };
    },

    methods: {
        richiestaRecuperoPassword() {
            this.errorString = "";
            this.loading = true;
            requests
                .restorePasswordReq(this.email)
                .then((res) => {
                    if (!_.isUndefined(res.response)) {
                        this.errorString = helpers.formatAjaxError(
                            res.response.data
                        );
                    } else {
                        this.sendedMail = true;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style></style>
